import { curry } from './function';
export const evolve = curry((fns, obj) => {
    const rtn = {};
    for (const [key, value] of Object.entries(obj)) {
        rtn[key] = typeof fns[key] === 'function'
            ? fns[key](value)
            : value;
    }
    return rtn;
});
export const isEmpty = (obj) => !Object.keys(obj).length;
export const filter = curry((filter, obj) => {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        if (filter(value, key)) {
            result[key] = value;
        }
    }
    return result;
});
